"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyDefaultPaymentRestrictions = applyDefaultPaymentRestrictions;
exports.displayMethodType = displayMethodType;
exports.displayPaymentHelpText = displayPaymentHelpText;
exports.getBasketStatus = getBasketStatus;
exports.getBookingConfirmationMessage = getBookingConfirmationMessage;
exports.getDonationForBooking = getDonationForBooking;
exports.getHotelBrand = getHotelBrand;
exports.getTotalCost = getTotalCost;
exports.isApplePayConfigured = isApplePayConfigured;
exports.isSecureBookingPage = isSecureBookingPage;
exports.isValidSecureBooking = isValidSecureBooking;
exports.shouldDisplaySecureBooking = shouldDisplaySecureBooking;
exports.sortImagesByOrder = sortImagesByOrder;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _validators = require("../validators");
function displayMethodType(method, variant) {
  var {
    type,
    name,
    card,
    subType
  } = method;
  switch (true) {
    case type === _api.PiCardType.NEW_PIBA && name === _api.CardName.PIBA_UK:
      return 'cc.NEW_PIBA_UK';
    case type === _api.PiCardType.NEW_PIBA && name === _api.CardName.PIBA_EU:
      return 'cc.NEW_PIBA_EURO';
    case type === _api.PiCardType.NEW_PIBA && subType === _api.PiCardSubType.PIBA_UK:
      return 'cc.NEW_PIBA';
    case type === _api.PiCardType.NEW_PIBA && subType === _api.PiCardSubType.PIBA_EU:
      return 'cc.NEW_PIBA_EURO';
    case type === _api.PiCardType.ACCOUNT_COMPANY:
      return 'cc.ACCOUNT_TO_COMPANY';
    case type === _api.PiCardType.RESERVE_WITHOUT_CARD:
      return 'paymentOptions.RESERVE_WITHOUT_CARD';
    case type === _api.PiCardType.AMEND_SAVED_CARD:
      return name;
    case type === _api.PiCardType.SAVED_CARD:
      if (variant === _api.Area.PI) {
        return card === null || card === void 0 ? void 0 : card.cardName;
      }
      return (card === null || card === void 0 ? void 0 : card.cardType) === _api.BusinessCardType.BUSINESS_PERSONAL_STORED_CARD ? 'booking.payment.storedcard.personal' : 'booking.payment.storedcard.central';
    case type === _api.PiCardType.PAYPAL_PAYMENT:
      return "booking.payment.paypal";
    default:
      return "cc.".concat(type);
  }
}
function displayPaymentHelpText(method) {
  var {
    type,
    card
  } = method;
  switch (type) {
    case _api.PiCardType.NEW_CARD:
    case _api.PiCardType.NEW_PIBA:
      return 'terms.infoNewCard';
    case _api.PiCardType.SAVED_CARD:
      return (card === null || card === void 0 ? void 0 : card.cardType) === _api.BusinessCardType.BUSINESS_CENTRALLY_STORED_CARD ? 'terms.infoSavedPibaCard' : 'cc.cvvRequired.info';
    case _api.PiCardType.APGP:
      return "terms.infoAPGP";
    case _api.PiCardType.PAYPAL_PAYMENT:
      return "terms.infoPayPal";
    default:
      return "cc.cvvRequired.info";
  }
}
function isApplePayConfigured() {
  var _ApplePaySession;
  return window !== undefined && ((_ApplePaySession = window.ApplePaySession) === null || _ApplePaySession === void 0 ? void 0 : _ApplePaySession.canMakePayments());
}
function getDonationForBooking(packages, donationPackages) {
  var _donationPackages$fin;
  var defaultDonation = {
    unitPrice: 0,
    code: ''
  };
  if (!packages || !donationPackages) {
    return defaultDonation;
  }
  return (_donationPackages$fin = donationPackages.find(pckg => (pckg === null || pckg === void 0 ? void 0 : pckg.code) === (packages === null || packages === void 0 ? void 0 : packages.id))) !== null && _donationPackages$fin !== void 0 ? _donationPackages$fin : defaultDonation;
}
function getTotalCost(ratePlanCode, totalCost, currency, packages, donationPackages, selectedDonation, variant) {
  var defaultTotalCost = {
    name: ratePlanCode,
    totalCost: {
      amount: totalCost,
      currency: currency
    }
  };
  if (variant === _api.Area.PI) {
    var bookingDonation = getDonationForBooking(packages, donationPackages);
    if (packages && (packages === null || packages === void 0 ? void 0 : packages.id) !== '' && (packages === null || packages === void 0 ? void 0 : packages.id) === (selectedDonation === null || selectedDonation === void 0 ? void 0 : selectedDonation.code)) {
      return defaultTotalCost;
    } else {
      var _bookingDonation$unit, _selectedDonation$uni;
      return {
        name: ratePlanCode,
        totalCost: {
          amount: String(+totalCost - ((_bookingDonation$unit = bookingDonation === null || bookingDonation === void 0 ? void 0 : bookingDonation.unitPrice) !== null && _bookingDonation$unit !== void 0 ? _bookingDonation$unit : 0) + ((_selectedDonation$uni = selectedDonation === null || selectedDonation === void 0 ? void 0 : selectedDonation.unitPrice) !== null && _selectedDonation$uni !== void 0 ? _selectedDonation$uni : 0)),
          currency: currency
        }
      };
    }
  }
  return defaultTotalCost;
}
function sortImagesByOrder(imageList) {
  var sortOrder = ['MC', 'VS', 'PP', 'AP', 'GP', 'AX'];
  var sortedImages = {};
  sortOrder.forEach(key => {
    if (imageList[key] !== undefined) {
      sortedImages[key] = imageList[key];
    }
  });
  for (var _key in imageList) {
    if (sortedImages[_key] === undefined) {
      sortedImages[_key] = imageList[_key];
    }
  }
  return sortedImages;
}
function applyDefaultPaymentRestrictions(paymentOptions, PaymentType, query, isSecureBookingFeatureEnabled) {
  var _paymentOptions$payme;
  if (!!isSecureBookingFeatureEnabled && !!paymentOptions && !!(paymentOptions !== null && paymentOptions !== void 0 && paymentOptions.paymentOptions) && !!(paymentOptions !== null && paymentOptions !== void 0 && (_paymentOptions$payme = paymentOptions.paymentOptions) !== null && _paymentOptions$payme !== void 0 && _paymentOptions$payme.length) && !!(query !== null && query !== void 0 && query.reservationId) && !!query['secure-booking'] && query['secure-booking'] === 'true') {
    paymentOptions.paymentOptions = paymentOptions.paymentOptions.filter(option => option.type !== PaymentType.RESERVE_WITHOUT_CARD);
    return paymentOptions;
  }
}
function isSecureBookingPage(query, isFeatureEnabled) {
  return !!isFeatureEnabled && !!(query !== null && query !== void 0 && query.reservationId) && !!query['secure-booking'] && query['secure-booking'] === 'true';
}
function getBookingConfirmationMessage(t, query, isFeatureEnabled) {
  var isSecureBooking = isSecureBookingPage(query, isFeatureEnabled);
  return isSecureBooking ? "".concat(t('nonguaranteed.booking.bookingSecure'), ",") : t('booking.confirmation.thankyouForBookingWithoutCustomerName');
}
function shouldDisplaySecureBooking(data, hotelBrand, isFeatureFlagEnabled) {
  var {
    arrivalDate,
    area,
    paymentOption,
    bookingStatus
  } = data;
  return isFeatureFlagEnabled && [_api.Area.PI, _api.Area.BB].includes(area) && (paymentOption === _api.paymentOptions.RESERVE_WITHOUT_CARD || bookingStatus === _api.BASKET_STATUS.PAY_PENDING) && bookingStatus !== _api.BC_RESERVATION_STATUS.CANCELLED && (0, _validators.validateArrivalDate)(arrivalDate, hotelBrand);
}
function getHotelBrand(data) {
  var _data$dehydratedState;
  var queries = (data === null || data === void 0 || (_data$dehydratedState = data.dehydratedState) === null || _data$dehydratedState === void 0 ? void 0 : _data$dehydratedState.queries) || [];
  for (var query of queries) {
    var _query$state;
    var brand = query === null || query === void 0 || (_query$state = query.state) === null || _query$state === void 0 || (_query$state = _query$state.data) === null || _query$state === void 0 || (_query$state = _query$state.hotelInformation) === null || _query$state === void 0 ? void 0 : _query$state.brand;
    if (brand) {
      return brand;
    }
  }
  return null;
}
function getBasketStatus(data) {
  var _data$dehydratedState2;
  var queries = (data === null || data === void 0 || (_data$dehydratedState2 = data.dehydratedState) === null || _data$dehydratedState2 === void 0 ? void 0 : _data$dehydratedState2.queries) || [];
  for (var query of queries) {
    var _query$state2;
    var basket = query === null || query === void 0 || (_query$state2 = query.state) === null || _query$state2 === void 0 || (_query$state2 = _query$state2.data) === null || _query$state2 === void 0 ? void 0 : _query$state2.basket;
    if (basket) {
      return basket;
    }
  }
  return null;
}
function isValidSecureBooking(_x, _x2, _x3) {
  return _isValidSecureBooking.apply(this, arguments);
}
function _isValidSecureBooking() {
  _isValidSecureBooking = (0, _asyncToGenerator2.default)(function* (featureToggles, loadedData, area) {
    var _loadedData$pcksQuery, _loadedData$pcksQuery2, _loadedData$pcksQuery3, _loadedData$pcksQuery4;
    var isSecureBookingFeatureEnabled = featureToggles[_api.FT_PI_BB_NON_GUARANTEED_REMINDER];
    var hotelBrand = getHotelBrand(loadedData);
    var basket = getBasketStatus(loadedData);
    var paymentOption = basket === null || basket === void 0 ? void 0 : basket.paymentOption;
    var basketStatus = basket === null || basket === void 0 ? void 0 : basket.status;
    var secureBookingData = {
      basketReference: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery === void 0 ? void 0 : _loadedData$pcksQuery.basketReferenceId,
      arrivalDate: (_loadedData$pcksQuery2 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery2 === void 0 ? void 0 : _loadedData$pcksQuery2.startDate,
      area,
      paymentOption,
      bookingStatus: basketStatus,
      hotelInfo: {
        hotelId: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery3 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery3 === void 0 ? void 0 : _loadedData$pcksQuery3.hotelId,
        bookingFlowId: loadedData === null || loadedData === void 0 || (_loadedData$pcksQuery4 = loadedData.pcksQueryInput) === null || _loadedData$pcksQuery4 === void 0 ? void 0 : _loadedData$pcksQuery4.bookingFlowId
      }
    };
    var isBookingValid = shouldDisplaySecureBooking(secureBookingData, hotelBrand, isSecureBookingFeatureEnabled);
    return {
      error: !isBookingValid
    };
  });
  return _isValidSecureBooking.apply(this, arguments);
}